import {observer_mgl} from "mobx-graphlink";
import {MapState} from "../../../../Store/main/maps/@MapState.js";
import {colors} from "../../../../Utils/UI/GlobalStyles.js";
import {Button, CheckBox, Row, Spinner, Text} from "react-vcomponents";
import React from "react";
import {store} from "../../../../Store/index.js";
import {RunInAction_Set} from "web-vcore";
import {MapTool} from "./Tools/@Tool.js";
import {DMap} from "../../../../Server/DB/maps/@Map.js";
import {zIndexes} from "../../../../Utils/UI/ZIndexes.js";

export const ToolDetailsUI = observer_mgl(({map, mapState}: {map: DMap, mapState: MapState})=>{
	const uiState = store.main.maps.tools;
	return (
		<Row center style={{height: 25, zIndex: zIndexes.actionBar, backgroundColor: colors.mapUI_panels}}>
			{/*uiState.activeTool == MapTool.meshModify && <ToolDetails_PolygonGrow {...{mapState}}/>*/}
			{(()=>{
				const Tool_RenderInToolbox_AsFuncComp = uiState.ActiveTool()?.RenderInToolbox;
				if (!Tool_RenderInToolbox_AsFuncComp) return null;
				return <Tool_RenderInToolbox_AsFuncComp data={{map, mapState}}/>;
			})()}
		</Row>
	);
});

/*const ToolDetails_PolygonGrow = observer_mgl(({mapState}: {mapState: MapState})=>{
	const toolState = store.main.maps.toolStates.meshModify;
	return (
		<>
			<Text>Size:</Text>
			<Spinner ml={5} min={0} step={.5} value={toolState.size} onChange={val=>RunInAction_Set(()=>toolState.size = val)}/>
			<CheckBox ml={5} text="Grow" value={toolState.grow} onChange={val=>RunInAction_Set(()=>toolState.grow = val)}/>
		</>
	);
});*/